import { PositionDetail } from '../components/PositionDetail';

export function TradeDetail() {
  return (
    <div>
      <PositionDetail />
    </div>
  );
}
